module.exports = __webpack_public_path__ + "static/media/size6.4483f15c.png";